module.exports = require('./lib/uslug');


//////////////////
// WEBPACK FOOTER
// ./node_modules/uslug/index.js
// module id = hQ8e
// module chunks = 0 111